export default "__VITE_ASSET__B$V5$I$L__"